import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { SelectChangeEvent } from '@mui/material';

import { ATSConnectHiringRequestRequestReferenceTestIds } from 'data-testids/ATS';
import { EmailDynamicSubstitutionObject, RequestReferenceCheckProps } from 'features/References';
import { EmailEditor } from './EmailEditor';
import { processText } from 'features/Connect/features/ConnectATSIntegration/utils/requestUtils';
import { ReferenceSelectAndLabel } from '../components/ContactTemplateSelect';
import { Stack, styled, Typography } from '@mui/material';
import { useQueryGetEmailTemplatesForReferences } from 'features/References';
import auth from 'utils/auth';

export const RequestReferenceCheck: React.FC<RequestReferenceCheckProps> = ({
  roleTitle,
  candidate,
}) => {
  const [emailTemplateId, setEmailTemplateId] = useState('');

  const { setValue } = useFormContext();
  const recipients = useWatch({ name: 'recipients' });
  const {
    data: emailTemplates,
    error,
    isLoading,
  } = useQueryGetEmailTemplatesForReferences(candidate.id);

  const handleChange = (event: SelectChangeEvent<string>) => {
    setEmailTemplateId(event.target.value);

    const selectedEmailTemplate = emailTemplates?.find(
      (emailTemplate) => emailTemplate.id === Number(event.target.value)
    );

    const objectToPass: EmailDynamicSubstitutionObject = {
      candidate,
      role: { title: roleTitle },
      sender: auth.getUser(),
      reference: recipients,
    };

    if (selectedEmailTemplate) {
      const message = processText(selectedEmailTemplate.content, objectToPass);
      const subject = processText(selectedEmailTemplate.subject, objectToPass);
      setValue('message', message, { shouldValidate: true });
      setValue('subject', subject, { shouldValidate: true });
      setValue('reference_id', recipients?.id);
    }
  };

  return (
    <Stack sx={{ pt: 3 }} spacing={2}>
      <SelectText variant="heading7">Select email template</SelectText>
      <ReferenceSelectAndLabel
        items={emailTemplates}
        dataTestId={ATSConnectHiringRequestRequestReferenceTestIds.EMAIL_TEMPLATE_SELECT}
        labelText=""
        value={emailTemplateId}
        placeholderText="Select Email Template"
        hasError={Boolean(error)}
        onChange={handleChange}
        isLoading={isLoading}
        shouldBeDisabled={!recipients}
      />
      <EmailEditor
        dataTestId={ATSConnectHiringRequestRequestReferenceTestIds.EMAIL_TEMPLATE_SELECT}
      />
    </Stack>
  );
};

export const SelectText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
}));
